const vndCurrency = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' });
const vndNumber = new Intl.NumberFormat('vi-VN');
const decimalNumber = new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2 });

export function toNumber(value: unknown): number {
  if (value == null) return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value === 'string') return Number(value) || 0;
  if (typeof value === 'object') {
    const record = value as Record<string, unknown>;
    if (typeof record.$numberDecimal === 'string') {
      return Number(record.$numberDecimal) || 0;
    }
    if (typeof record.value === 'string' || typeof record.value === 'number') {
      return Number(record.value) || 0;
    }
  }
  return Number(value) || 0;
}

export function formatVND(n: unknown): string {
  return vndCurrency.format(toNumber(n));
}

export function formatNumber(n: unknown): string {
  return vndNumber.format(toNumber(n));
}

/**
 * Số lẻ (ngày nghỉ, giờ công...) làm tròn 2 chữ số thập phân.
 *
 * `formatNumber` KHÔNG dùng được cho việc này: `Intl.NumberFormat` mặc định tối đa 3
 * chữ số thập phân, nên tổng ngày nghỉ cộng từ nhiều đơn nửa ngày vẫn ra kiểu
 * `119,246`. Còn giá trị thô thì hiện nguyên `119.24603174603175`.
 */
export function formatDecimal(n: unknown): string {
  return decimalNumber.format(toNumber(n));
}

/**
 * InputNumber antd 5 gọi `formatter(value, { userTyping, input })`.
 * Lúc gõ: format từ chuỗi đang nhập để dấu chấm nghìn tự cập nhật. Bỏ số 0
 * ở đầu (`05` → `5`) — giữ lại đúng một `0` nếu giá trị là không.
 */
export function moneyFormatter(
  value?: number | string,
  info?: { userTyping?: boolean; input?: string },
): string {
  const raw =
    info?.userTyping && typeof info.input === 'string'
      ? info.input
      : `${value ?? ''}`;
  const digits = stripLeadingZeros(raw.replace(/\D/g, '').slice(0, 12));
  if (!digits) return '';
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function moneyParser(display?: string): number {
  const digits = stripLeadingZeros((display ?? '').replace(/\D/g, '').slice(0, 12));
  return digits === '' ? 0 : Number(digits);
}

function stripLeadingZeros(digits: string): string {
  return digits.replace(/^0+(?=\d)/, '');
}

export function formatDate(iso: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatDateTime(iso: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleString('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export function formatDateTimeFull(iso: string): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
